export interface PublishTierOverride {
    expires?: number;
    publishTier?: string;
}

export const PublishTierOverrideFields = 'expires publishTier';
